import Component from "../../../../js/assets/component.js"

class TabContent extends Component {
  constructor(el) {
    super(el);
  }

  // define data
  data() {
    return {
      "activeIndex": 0,
      "navFixed": false,
      "navHidden": false
    }
  }

  // action at data changed
  changed() {
    return {
      "activeIndex": (val, prev) => {
        this.changeTab(val, prev)
      },
      "navFixed": (val) => {
        if(val===true){
          this.fixNav()
        }else{
          this.unpinNav()
        }
      },
      "navHidden": (val) => {
        if(val===true){
          this.hideNav()
        }else{
          this.displayNav()
        }
      }
    }
  }

  changeTab(index, prev) {
    for(let i=0; i<this.navList.length; i++){
      if(i===index){
        this.navList[i].addClass("-active")
      }else{
        this.navList[i].removeClass("-active")
      }
    }

    for(let i=0; i<this.contentList.length; i++){
      this.contentList[i].addClass("-moving")
      if(i===index){
        // this.contentList[i].removeClass("-moving")
        this.contentList[i].addClass("-active")
      }else{
        this.contentList[i].removeClass("-active")
        // this.contentList[i].addClass("-moving")
      }
    }

    //slide container
    this.$tabContainer
      .stop(false,false)
      .animate({
        left: (index * -105) + "%"
      }, {
        duration: 1000,
        easing: "easeInOutQuart",
        complete: ()=>{
          for(let i=0; i<this.contentList.length; i++){
            this.contentList[i].removeClass("-moving")
            // if(i!==index){
            //   this.contentList[i].removeClass("-moving")
            // }
          }
        }
      })
  }

  fixNav(){
    this.$el.addClass("-navFixed")
  }

  unpinNav(){
    this.$el.removeClass("-navFixed")
  }

  hideNav(){
    this.$el.addClass("-navHidden")
  }

  displayNav(){
    this.$el.removeClass("-navHidden")
  }

  //can access this.$el and this.el
  mounted() {
    var self = this

    self.$tabContainer = self.$el.find(".tabContentBlock_content")
    self.navList = []
    self.contentList = []

    self.$el.find(".primaryNav_item").each(function(){
      self.navList.push($(this))
    })

    self.$el.find(".tabContentBody").each(function(){
      self.contentList.push($(this))
    })
    for(let i=0; i<this.navList.length; i++){
      self.navList[i].find("> a[href]").on("click", function(e){
        self.$data.activeIndex = i
        return false
      })
    }

    if (typeof self.$el.data("initialActiveIndexFromOne") !== 'undefined') {
      self.$data.activeIndex = parseInt(self.$el.data("initialActiveIndexFromOne")) - 1
    }

    //prev next link
    self.$el.find("[data-index]").each(function(){
      let index = Number($(this).attr("data-index"))
      $(this).on("click", function(){
        self.$data.activeIndex = index
      })
    })

    //nav placeholder
    this.$tabNav = this.$el.find(".block_header")
    this.$tabNavPlaceholder = this.$tabNav.clone(false)
    this.$tabNavPlaceholder.addClass("placeholder")
    this.$tabNav.before(this.$tabNavPlaceholder)
  }
}


export default TabContent
